import dynamic from 'next/dynamic';
import { ImageBannerProps } from './ImageBanner.types';

export const ImageBanner = dynamic<{ model: ImageBannerProps }>(() =>
  import('./ImageBanner').then(mod => mod.ImageBanner)
);
